import { css } from "styled-components";
import { DeviceBreakpoints } from "@app/styles/variables/breakpoints";

export const cardStyles = css`
    :root {
        --dit-components-card-padding: 1rem;
    }

    .dit-components-card-unstyled {
        padding: 1rem;
    }

    .dit-components-card {
        overflow: hidden;

        &:not(.flush) {
            border: 1px solid var(--dit-layout-color-card-border--map) !important;
        }

        &.dit-components-card-raised {
            box-shadow: var(--dit-layout-shadow-card--map) !important;
        }

        // TODO: temporary fix
        @media ${DeviceBreakpoints.DESKTOP.from} {
            &.flush {
                padding: 0 !important;
            }
        }
    }

    .dit-components-card-header {
        background-color: var(--dit-layout-color-card-header-background--map);
        color: var(--dit-layout-color-card-header--map);
        font-size: var(--dit-layout-font-size-card-header--map);
        font-weight: var(--dit-layout-font-weight-card-header--map);
        border-radius: inherit;

        a {
            color: var(--dit-layout-color-card-header-link--map);

            &:link {
                color: var(--dit-layout-color-card-header-link--map);
            }

            &:visited {
                color: var(--dit-layout-color-card-header-link--map);
            }

            &:focus {
                color: var(--dit-layout-color-card-header-link-focus--map);
                border-radius: 0.25rem;
            }

            &:hover {
                color: var(--dit-layout-color-card-header-link-hover--map);
            }

            &:active {
                color: var(--dit-layout-color-card-header-link-active--map);
            }
        }
    }
    .dit-components-card-body {
        color: var(--dit-layout-color-card-body--map);
        background-color: var(--dit-layout-color-card-body-background--map);
        border-radius: inherit;
        font-size: var(--dit-layout-font-size-card-body--map);
        font-weight: var(--dit-layout-font-weight-card-body--map);

        a {
            color: var(--dit-layout-color-card-body-link--map);

            &:link {
                color: var(--dit-layout-color-card-body-link--map);
            }

            &:visited {
                color: var(--dit-layout-color-card-body-link--map);
            }

            &:focus {
                color: var(--dit-layout-color-card-body-link-focus--map);
                border-radius: 0.25rem;
            }

            &:hover {
                color: var(--dit-layout-color-card-body-link-hover--map);
            }

            &:active {
                color: var(--dit-layout-color-card-body-link-active--map);
            }
        }
    }
    .dit-components-card-footer {
        color: var(--dit-layout-color-card-footer--map);
        background-color: var(--dit-layout-color-card-footer-background--map);
        font-size: var(--dit-layout-font-size-card-footer--map);
        font-weight: var(--dit-layout-font-weight-card-footer--map);

        a:not(.button-link) {
            color: var(--dit-layout-color-card-body-link--map);

            &:link {
                color: var(--dit-layout-color-card-body-link--map);
            }

            &:visited {
                color: var(--dit-layout-color-card-body-link--map);
            }

            &:focus {
                color: var(--dit-layout-color-card-body-link-focus--map);
                border-radius: 0.25rem;
            }

            &:hover {
                color: var(--dit-layout-color-card-body-link-hover--map);
            }

            &:active {
                color: var(--dit-layout-color-card-body-link-active--map);
            }
        }
    }
`;
